import { isFeatureEnabled } from 'owa-feature-flags';
import { getHostHub } from 'owa-config';
import { isCopilotLicensedAndEnabledUser } from './isCopilotLicensedAndEnabledUser';

export function isCalendarEventFormV2Enabled(): boolean {
    const isFormV2EnabledForNonCopilotUsers = isFeatureEnabled('cal-forms-v2');
    return (
        isFormV2EnabledForNonCopilotUsers ||
        isModalFormEnabledForCopilotUsers() ||
        isInlineFormEnabledForCopilotUsers()
    );
}

export function isModalFormEnabledForCopilotUsers(): boolean {
    return isCopilotLicensedAndEnabledUser() && isFeatureEnabled('cal-forms-v2-copilot-modal');
}

export function isInlineFormEnabledForCopilotUsers(): boolean {
    const isCopilotSidePaneFeatureEnabled =
        getHostHub() === 'teamshub'
            ? isFeatureEnabled('cal-teams-copilot')
            : isFeatureEnabled('mon-copilot-bizchat');
    return (
        isCopilotLicensedAndEnabledUser() &&
        isFeatureEnabled('cal-forms-v2-copilot-inline-i1') &&
        isCopilotSidePaneFeatureEnabled
    );
}
